<template>
  <div>
    <sub-page-header :title="$t('account_history.title')" />
    <div class="container">
      <h2 class="title center mt-4" v-t="'account_history.time'"></h2>
      <div class="time-period bolder center">
        {{ starPeriod }} - {{ endPeriod }}
      </div>
      <div class="account-history mt-4">
        <div class="loading-ani" v-if="accountHistoryPending">
          <app-loading-ani class="loading-ani" />
        </div>
        <template v-else>
          <div class="accounthistory-info-box">
            <div class="label bold" v-t="'account_history.total'"></div>
            <div class="data">
              <span class="bolder">
                {{
                  formatCurrency(accountHistoryEntry.total, {
                    includeEuro: false,
                  })
                }}
              </span>
              <span class="euro">&euro;</span>
            </div>
          </div>
          <div class="accounthistory-info-box">
            <div class="label" v-t="'account_history.voice'"></div>
            <div class="data">
              <span class="bolder">
                {{
                  formatCurrency(accountHistoryEntry.voice, {
                    includeEuro: false,
                  })
                }}
              </span>
              <span class="euro">&euro;</span>
            </div>
          </div>
          <div class="accounthistory-info-box">
            <div class="label" v-t="'account_history.sms'"></div>
            <div class="data">
              <span class="bolder">
                {{
                  formatCurrency(accountHistoryEntry.sms, {
                    includeEuro: false,
                  })
                }}
              </span>
              <span class="euro">&euro;</span>
            </div>
          </div>
          <div class="accounthistory-info-box">
            <div class="label" v-t="'account_history.data'"></div>
            <div class="data">
              <span class="bolder">
                {{
                  formatCurrency(accountHistoryEntry.data, {
                    includeEuro: false,
                  })
                }}
              </span>
              <span class="euro">&euro;</span>
            </div>
          </div>
          <div class="accounthistory-info-box">
            <div class="label" v-t="'account_history.additional'"></div>
            <div class="data">
              <span class="bolder">
                {{
                  formatCurrency(accountHistoryEntry.additional, {
                    includeEuro: false,
                  })
                }}
              </span>
              <span class="euro">&euro;</span>
            </div>
          </div>
        </template>
      </div>
      <div class="browse-buttons mt-4">
        <button
          @click="goBack"
          :class="{ hide: hideBack }"
          class="button button--white back"
          v-t="'general.back'"
        ></button>
        <button
          :class="{ hide: hideForward }"
          @click="goForward"
          class="button button--white forward"
          v-t="'general.forward'"
        ></button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import moment from 'moment';
import formatCurrency from '@/plugins/currency-formatter';
import SubPageHeader from '@/components/SubPageHeader';
import AppLoadingAni from '@/components/AppLoadingAni';
export default {
  data() {
    return {
      accountCreated: moment(this.$store.getters['user/user'].validFrom),
      currentPeriod: moment(),
    };
  },
  components: {
    AppLoadingAni,
    SubPageHeader,
  },
  mounted() {
    this.fetchAccountHistory();
  },
  computed: {
    ...mapState('accounthistory', [
      'accountHistoryEntry',
      'accountHistoryPending',
    ]),
    starPeriod() {
      const currentPeriodStart = moment(this.currentPeriod).startOf('month');
      if (currentPeriodStart.isBefore(this.accountCreated)) {
        return this.accountCreated.format('D.M');
      }
      return currentPeriodStart.format('D.M');
    },
    endPeriod() {
      const currentPeriodEnd = moment(this.currentPeriod).endOf('month');
      if (currentPeriodEnd.isAfter(moment())) {
        return moment().format('D.M.YYYY');
      }
      return currentPeriodEnd.format('D.M.YYYY');
    },
    hideBack() {
      return moment(this.currentPeriod)
        .startOf('month')
        .isBefore(this.accountCreated);
    },
    hideForward() {
      return moment(this.currentPeriod)
        .endOf('month')
        .isAfter(moment());
    },
  },
  methods: {
    fetchAccountHistory() {
      this.$store.dispatch('accounthistory/fetch', {
        year: this.currentPeriod.year(),
        month: this.currentPeriod.format('MM'),
      });
    },
    goBack() {
      this.currentPeriodStart = this.currentPeriod.subtract(1, 'month');
      this.fetchAccountHistory();
    },
    goForward() {
      this.currentPeriodStart = this.currentPeriod.add(1, 'month');
      this.fetchAccountHistory();
    },
    formatCurrency,
  },
};
</script>

<style lang="scss" scoped>
.hide {
  visibility: hidden;
}
.time-period {
  font-size: 1.5rem;
}
.title {
  font-size: 1rem;
}
.browse-buttons {
  display: flex;
  justify-content: space-between;
  .forward {
    margin-left: auto;
  }
}
.account-history {
  position: relative;
  box-shadow: 0 1px 5px 1px rgba(#d4d4d4, 0.5);
  border-radius: 5px;
  min-height: 450px;
  background-color: white;

  .loading-ani {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}
.accounthistory-info-box {
  padding: 2rem 1rem;
  background-color: white;
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid $light-gray;
  &:first-child {
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
  }
  &:last-child {
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
  }
  .data {
    font-weight: bold;
    font-size: 125%;
  }
}
</style>
